import { Directive, HostListener } from '@angular/core';

import { TextHelper } from '../helpers/text.helper';

@Directive({
    selector: '[appSanitizeSpaceAndLineBreak]'
})
export class SanitizeSpaceAndLineBreakDirective {

    constructor(
        private textHelper: TextHelper
    ) { }

    @HostListener('input', ['$event'])
    onInput(event: Event): void {

        const inputEl = event.target as HTMLInputElement | HTMLTextAreaElement;
        const value = inputEl.value;


        const sanitizedValue = this.textHelper.getSanitizedUpdateText(value);
        if (sanitizedValue === value) return;

        inputEl.value = sanitizedValue;
    }

}

